import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'transformUrl',
})
export class TransformUrlToBgPipe implements PipeTransform {
  transform(value = ''): string {
    return value.length ? 'url(' + value + ')' : 'none';
  }
}
